import React from 'react';
import { useNavigate } from 'react-router-dom';
import { ArrowLeftIcon } from '@heroicons/react/24/outline';

const BackButton = ({ to, label = 'Back' }) => {
  const navigate = useNavigate();

  const onClick = () => {
    if (to) {
      navigate(to);
    } else {
      navigate(-1);
    }
  };

  return (
    <button
      type="button"
      onClick={onClick}
      className="inline-flex items-center text-sm text-gray-600 hover:text-gray-900"
      aria-label={label}
    >
      <ArrowLeftIcon className="h-5 w-5 mr-1" />
      {label}
    </button>
  );
};

export default BackButton;